var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_509_820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 20.25H21.25C22.2165 20.25 23 19.4665 23 18.5V5.5C23 4.5335 22.2165 3.75 21.25 3.75H2.75C1.7835 3.75 1 4.5335 1 5.5V18.5C1 19.4665 1.7835 20.25 2.75 20.25Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.25H21.25C22.2165 20.25 23 19.4665 23 18.5V5.5C23 4.5335 22.2165 3.75 21.25 3.75H2.75C1.7835 3.75 1 4.5335 1 5.5L13 20.25Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37207 20.25H21.2496C22.2161 20.25 22.9996 19.4665 22.9996 18.5V5.75L3.37207 20.25Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8727 20.25H21.2502C22.2167 20.25 23.0002 19.4665 23.0002 18.5V5.75L9.38574 15.808L12.8727 20.25Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 4.74997H2.75C1.7835 4.74997 1 4.53347 1 5.49997V18.5C1 19.4665 1.7835 20.25 2.75 20.25H3.5V5.99997H20.5V20.25H21.25C22.2165 20.25 23 19.4665 23 18.5V5.49997C23 4.53347 22.2165 4.74997 21.25 4.74997Z",
    fill: "#CA3737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 3.75H12H2.75C1.7835 3.75 1 4.518 1 5.5C1 6.103 1.759 6.629 1.759 6.629L12 13.878L22.241 6.6295C22.241 6.6295 23 6.103 23 5.5005C23 4.518 22.2165 3.75 21.25 3.75Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.623 3.79102L12 10.5L2.377 3.79102C1.59 3.95952 1 4.64852 1 5.50002C1 6.10302 1.759 6.62902 1.759 6.62902L12 13.878L22.241 6.62952C22.241 6.62952 23 6.10302 23 5.50052C23 4.64852 22.41 3.95952 21.623 3.79102Z",
    fill: "#E84F4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_509_820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.a7d210a22e6d0faa77b513d18bb9115f.svg";
export { ForwardRef as ReactComponent };